import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowLeft from '@/images/arrows/ArrowLeft.svg';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { IconButton, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useClearForm } from '../../hooks';
import { CampaignTabs } from './CampaignTabs';
import { HeaderButtons } from './HeaderButtons';
import { Name } from './Name';

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    background-color: ${({ theme }) => theme.colors.white};
    height: 81px;
    min-height: 81px;
    position: relative;
    border-bottom: 1px solid ${({ theme }) => theme.colors.black[300]};
`;

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 300px;
`;

const StyledBackButton = styled(IconButton)`
    padding: 0;
    border-radius: 12px;
    height: 40px;

    &:active {
        background-color: ${({ theme }) => theme.colors.black[50]};
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
    }
`;

export const Header = observer(() => {
    const theme = useTheme();
    const navigate = useNavigate();
    const clearForm = useClearForm();

    const handleBack = () => {
        clearForm();
        navigate(AppRoutes.Campaigns);
    };

    return (
        <HeaderContainer>
            <NameWrapper>
                <StyledBackButton onClick={handleBack}>
                    <MaskedIcon src={ArrowLeft} size="32px" color={theme.colors.black[700]} />
                </StyledBackButton>
                <Name />
            </NameWrapper>
            <CampaignTabs />
            <HeaderButtons />
        </HeaderContainer>
    );
});
